import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V3 } from '@studio/constants/env-variables';
import type API from '@resi-media/api-types';

export const root = {
  [HTTP_METHODS.POST]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/contentdestinations/@destinationId/republish`,
    request: {} as API.Central.V3.ContentDestinations.Post.Republish.Request,
    params: {} as { destinationId: string },
    method: HTTP_METHODS.POST,
  },
};
